import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var SpotKidsFamilyComponent = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 24,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'SpotKidsFamily',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "#1C84A0",
    fillRule: "evenodd",
    d: "M6.247 18.776a3.708 3.708 0 0 0 3.708-3.707h2a5.708 5.708 0 0 1-5.708 5.707v-2ZM18 18.484a3.708 3.708 0 0 1-3.708-3.708h-2A5.708 5.708 0 0 0 18 20.484v-2Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#1C84A0",
    d: "M9.052 8c-1.538 0-2.948.412-4.042 1.097v.415h7.998V9.02C11.948 8.504 10.636 8 9.052 8Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#28BBDD",
    d: "M22.037 8.975c-.03-4.553-4.693-7.023-9.623-6.926l-.068 7.255H5.999c-.01-.348 0-1.07 0-1.302 0-.842-.361-1.604-.855-2.282-.775-1.065-1.87-1.278-1.996-1.298a.949.949 0 0 0-1.114.785.967.967 0 0 0 .795 1.114s.435.097.745.523c.252.349.438.722.438 1.158v2.77c0 2.664 2.13 4.867 4.793 4.867h8.398c3.904.02 4.853-4.01 4.834-6.664ZM7.764 22.1a2.406 2.406 0 0 0 2.412-2.412 2.406 2.406 0 0 0-2.412-2.412 2.406 2.406 0 0 0-2.412 2.412A2.406 2.406 0 0 0 7.764 22.1ZM16.82 22.1a2.406 2.406 0 0 0 2.413-2.412 2.406 2.406 0 0 0-2.412-2.412 2.406 2.406 0 0 0-2.412 2.412A2.406 2.406 0 0 0 16.82 22.1Z"
  }));
};
SpotKidsFamilyComponent.displayName = 'SpotKidsFamily';
export var SpotKidsFamily = withProvisionalOverrideFromContext(SpotKidsFamilyComponent);
//# sourceMappingURL=index.js.map